import { render, staticRenderFns } from "./403.vue?vue&type=template&id=c04262a8&scoped=true"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"
import style0 from "./403.vue?vue&type=style&index=0&id=c04262a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04262a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
